module.exports = __webpack_public_path__ + "static/media/notification-banner.424992a7.png";